export default "__VITE_ASSET__pzHtPwWQ__"